<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ Instructor Type </span>
    </v-row><br />
    <v-card>
        <v-card-title>Instructor Type</v-card-title>
      <v-card-text>
      </v-card-text>
    </v-card>
    
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
  }),
  watch: {
    config() {
     // this.config_value = null;
    }
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    axios
      .post("/adminMaster/instructorType")
      .then(res => {
         this.showSnackbar("#4CAF50","Success")
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
      })
      .finally(() => {});
  }
};
</script>